const StudentStats = ({ stats }) => (
  <>
    <ul className="list-disc pl-5 mb-4 theme-text">
      <li>📘 Enrolled Courses: {stats.enrolledCourses || 0}</li>
      <li>📝 Assignments Due: {stats.assignments || 0}</li>
      <li>📈 Avg. Score: {stats.averageScore || 0}%</li>
    </ul>

    <div className="mt-4 space-y-4">
      <div>
        <h3 className="font-semibold mb-1 theme-text">🎓 Education</h3>
        <p className="theme-text"><strong>Degree:</strong> {stats.education?.degree || "N/A"}</p>
        <p className="theme-text"><strong>University:</strong> {stats.education?.university || "N/A"}</p>
        <p className="theme-text"><strong>Year of Passing:</strong> {stats.education?.yearOfPassing || "N/A"}</p>
        <p className="theme-text"><strong>Percentage:</strong> {stats.education?.percentage || "N/A"}</p>
      </div>

      <div>
        <h3 className="font-semibold mb-1 theme-text">📚 Training</h3>
        {(stats.training || []).map((item, index) => (
          <p key={index} className="theme-text">✅ {item.courseName} ({item.trainer})</p>
        ))}
      </div>

      <div>
        <h3 className="font-semibold mb-1 theme-text">📊 Performance</h3>
        {(stats.performance || []).map((item, index) => (
          <p key={index} className="theme-text">{item.subject}: {item.score}%</p>
        ))}
      </div>

      <div>
        <h3 className="font-semibold mb-1 theme-text">💻 Projects</h3>
        {(stats.projects || []).map((item, index) => (
          <p key={index} className="theme-text"><strong>{item.title}:</strong> {item.description}</p>
        ))}
      </div>

      <div>
        <h3 className="font-semibold mb-1 theme-text">🏢 Placement</h3>
        <p className="theme-text"><strong>Company:</strong> {stats.placement?.companyName || "N/A"}</p>
        <p className="theme-text"><strong>Interview Date:</strong> {stats.placement?.interviewDate || "N/A"}</p>
        <p className="theme-text"><strong>Result:</strong> {stats.placement?.result || "N/A"}</p>
        <p className="theme-text"><strong>Offer:</strong> {stats.placement?.offerDetails || "N/A"}</p>
      </div>
    </div>
  </>
);

export default StudentStats;



